// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest } from '@/libs/axios';

// 分页查询有效监测范围
export const _getScopes = (params) => {
    return getRequest('/monitorScope/getScopes', params)
};

//添加或修改监测内容
export const _insertOrUpdate = (params) => {
    return postRequest('/copyrightMonitorContent/insertOrUpdate', params)
};

//通过id获取监测内容详情
export const _getContent = (id,params) => {
    return getRequest(`/copyrightMonitorContent/getContent/${id}`, params)
};

//分页查询有效监测内容
export const _getValidByPage = (params) => {
    return getRequest('/copyrightMonitorData/getValidByPage', params)
};

//监测数据统计
export const _monitorTotal = (params) => {
    return getRequest('/copyrightMonitorData/monitorTotal', params)
};

//我的监测-分页查询有效监测内容
export const _contentGetValidByPage = (params) => {
    return getRequest('/copyrightMonitorContent/getValidByPage', params)
};

